<div class='appt-time-loader' style="margin-left: 150px;" *ngIf="(availabilityOptionsLoading$ | async)">
 <app-loading size=".5"></app-loading>
</div>
<div *ngIf="apptType === 'Service'">
  <div class='appointment-container' *ngIf="!(availabilityOptionsLoading$ | async)">
    <form [formGroup]='step' appConnectStore="availabilityForm">
      <div class='availability'>
       
  
        <app-availability class='app-availability'
                          formControlName='availability'
                          [options]="availabilityOptions$ | async"
                          [source]="'dashboard'"
                          [selectedTransport]="transport"
                          [vin]="vehicle?.vin"
                          [isAvailabilityLoading]="availabilityLoading$ | async"
                          [availability]="availability$ | async"
                          [apptType]="apptType"
                          (monthChanged)="onMonthChange($event)"
                          [checklistDuration]="checklistDuration"
                          (timeSlotValidator)="setValidatorsForTimeSlot($event)"
                          [isEditMode]="true"
                          [customerLanguage]="languageId"
                          [apptAdvisor] = "apptAdvisor"
                          [appointmentId]="apptId"
                          [data]="data">
        </app-availability>
      </div>
    </form>
  </div>
</div>
<div *ngIf="apptType !== 'Service'">
  <div class='appointment-container' *ngIf="!(availabilityOptionsLoading$ | async)">
    <form [formGroup]='step'>
      <div class='availability'>
       
  
        <app-availability class='app-availability'
                          formControlName='availability'
                          [options]="availabilityOptions$ | async"
                          [source]="'dashboard'"
                          [selectedTransport]="transport"
                          [vin]="vehicle?.vin"
                          [isAvailabilityLoading]="availabilityLoading$ | async"
                          [availability]="availability$ | async"
                          [apptType]="apptType"
                          (monthChanged)="onMonthChange($event)"
                          [checklistDuration]="checklistDuration"
                          (timeSlotValidator)="setValidatorsForTimeSlot($event)"
                          [isEditMode]="true"
                          [customerLanguage]="languageId"
                          [appointmentId]="apptId"
                          [data]="data">
        </app-availability>
      </div>
    </form>
  </div>
</div>